import {
  BsYoutube,
  BsInstagram,
  BsLinkedin,
  BsFacebook,
  BsGithub,
} from "react-icons/bs";
import { FaGoodreads, FaGooglePay } from "react-icons/fa";

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://github.com/hareeshdwivedi" target="_blank">
        <BsGithub />
      </a>
    </div>
    <div>
      <a href="https://www.linkedin.com/in/hareesh-dwivedi/" target="_blank">
        <BsLinkedin />
      </a>
    </div>
  
    <div>
      <a href="https://www.instagram.com/hareeshvns" target="_blank">
        <BsInstagram />
      </a>
    </div>



  </div>
);

export default SocialMedia;
